import Auth from 'modules/Auth';
import { PermissionsEnum } from 'consts/permissions';
import { FeatureFlags } from 'components/common/types/Features.types';
import { Store } from 'components/common/types/Store.types';

export const getHasDealReadOnlyPermission = (state: Store): boolean => {
  const arePermissionsEnabled =
    state.publisher?.publisherFeatures?.[FeatureFlags.PLANNERS_PERMISSIONS]?.includes(
      state.environment?.environmentId,
    ) ?? false;

  return arePermissionsEnabled && Auth.hasPermission(PermissionsEnum.DEAL_READ_ONLY);
};
